import React, { FunctionComponent, useMemo } from 'react';
import IGame from '@interfaces/IGame';
import Image from '@components/Image';
import css from './GameCard.module.less';
import { Card } from 'antd';
import { CloseCircleOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import { setList } from '@stores/gamesSelector';
import { openModal } from '@stores/modals';
import { goTo } from '@helpers/navigation';
import componentContent from './GameCard.content.json';
import useTranslate from '../../hooks/useTranslate';
import { LOCALE } from '@stores/localeWeight';
import GameCardCell from './GameCardCell';

const { Meta } = Card;

interface GameCardProps {
  game?: IGame;
  mode: 'card' | 'row';
}

const GameCard: FunctionComponent<GameCardProps> = ({ game, mode }) => {
  const searchPosts = () => {
    if (!game) return;
    setList([game]);
    goTo('postList', undefined, { gameId: game.id });
  };

  const content = useTranslate(componentContent);

  const urlImage = useMemo(() => {
    const currentLocale = localStorage.getItem('localeWeight') as LOCALE;
    const locale = game?.gameLocales?.find((gameLocale) => gameLocale.locale === currentLocale);
    if (locale && locale?.image?.url) return locale?.image?.url;

    return game?.image?.url || '';
  }, [game]);

  const name = useMemo(() => {
    const currentLocale = localStorage.getItem('localeWeight') as LOCALE;
    if (currentLocale === LOCALE.EN) {
      return game?.name || '';
    }

    const locale = game?.gameLocales?.find((gameLocale) => gameLocale.locale === currentLocale);
    if (locale && locale?.name) return locale?.name;

    return game?.name || '';
  }, [game]);

  if (mode === 'card') {
    return (
      <Card
        hoverable
        className={css.root}
        cover={game ? <Image url={urlImage} className={css.image} /> : <CloseCircleOutlined />}
        actions={[
          <EditOutlined key="edit" onClick={() => openModal({ name: 'game', data: game })} />,
          <SearchOutlined key="search" onClick={searchPosts} />,
        ]}
      >
        <Meta
          title={game ? name : content.notFound}
          description={game ? game.description : content.notFound}
        />
      </Card>
    );
  }

  if (mode === 'row') {
    return (
      <GameCardCell
        game={game}
        text={name}
        synonyms={game?.synonyms}
        urlImg={urlImage}
        isEmpty={!game}
      />
    );
  }

  return null;
};

export default GameCard;
